import React from 'react'
import { Link } from 'react-router-dom'
import FormFactory from '../../../../components/form/form-factory'

import {
  Header,
  Section,
  Container,
  H3,
  Article,
  Img1,
  Img2,
  Img3,
  WrapperAddImg,
  Article2,
  Article3,
  WrapperHeader,
} from './styles' // Certifique-se de importar os estilos necessários

import arrowLeft from '../../../../assets/svg/arrow-left-line.svg'
import FAQ from '../../../../assets/svg/FAQ.svg'
import addImage from '../../../../assets/svg/addImage.svg'
import plus from '../../../../assets/svg/add-one.svg'
import userGreen from '../../../../assets/svg/userGreen.svg'

import IFormPage from '../../../../interfaces/form-page'
import logoIntro from '../../../../assets/png/logo-intro.png'

type IProps = any & IFormPage

const Signup2Doctor = ({
  dataForm,
  onSubmit,
  errorMessage,
  backButton,
  selectedImage,
  handleImageSelect,
}: IProps): JSX.Element => (
  <>
    <Link to="/signup/doctor" style={{ textDecoration: 'none' }}>
      <Header>
        <img src={arrowLeft} alt="Voltar" />
        Cadastro
      </Header>
    </Link>
    <Container>
      <WrapperHeader>
        <img src={logoIntro} alt="Logo" width="30%" />
        <Link to="/faq/MEDICO">
          <img src={FAQ} alt="FAQ" />
        </Link>
      </WrapperHeader>
      <Section>
        Passo 2 de 4
        <H3>
          Adicione uma&nbsp;
          <Article>imagem de perfil</Article>
        </H3>
      </Section>
      {!selectedImage ? (
        <WrapperAddImg>
          <Img1 src={addImage} alt="Adicionar imagem" />
          <label htmlFor="fileInput" style={{ cursor: 'pointer' }}>
            <Img2 src={plus} alt="Adicionar imagem" />
          </label>
          <input
            id="fileInput"
            type="file"
            accept="image/*"
            onChange={handleImageSelect}
            style={{ display: 'none' }}
          />
          <Img3 src={userGreen} alt="Adicionar imagem" />
        </WrapperAddImg>
      ) : (
        <WrapperAddImg>
          <Img1 src={selectedImage} alt="Foto selecionada" />
          <label htmlFor="fileInput" style={{ cursor: 'pointer' }}>
            <Img2 src={plus} alt="Adicionar imagem" />
          </label>
          <input
            id="fileInput"
            type="file"
            accept="image/*"
            onChange={handleImageSelect}
            style={{ display: 'none' }}
          />
        </WrapperAddImg>
      )}
      <Article2>
        Esta imagem não será
        <br />
        divulgada para os contratantes
      </Article2>
      <Article3>
        Extensões de arquivos aceitas: JPEG e JPG
        <br />
        <br />
        Tamanho máximo suportado: 10MB
      </Article3>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
        backButton={backButton}
      />
    </Container>
  </>
)

export default Signup2Doctor
